<template>
  <b-row align-v="end" align-h="between" class="row mx-0">
    <b-col class="d-flex justify-content-center mb-0">
      <h3>{{ org_name }}</h3>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton, BLink, BAvatar } from "bootstrap-vue";
import axios from "axios";

export default {
  props: ["collapsed"],
  data() {
    return {
      org_name: "",
    }
  },
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
    BAvatar,
  },
  async mounted() {
    const { data } = await axios.get(
      `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients/info`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    this.org_name = data['org_name'];
  },
  methods: {
    sidebarCollapsed(check) {
      this.$emit("sidebarCollapsedProps", check);
    },
  },
};
</script>
